import { createAction } from '@reduxjs/toolkit';
import { buildReducer } from '../../utils/redux/getReduxModuleByFeatureName';
import { matchPath } from 'connected-react-router';
import { LOCATION_CHANGE } from 'connected-react-router';
import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import { initialState as baseInitState } from '../../utils/redux/commonActionHandlers';

const routeConfig = { path: '/users/:id/:tab' };

const initialState = { 
  ...baseInitState, 
  data: null,
  ownerPool: {
    loading: false,
    error: null,
    history: [],
    showAssignDialog: false,
    showHistoryDialog: false,
  },
};
const constants = {
  ...getConstantsByFeatureName('USER_DETAILS_PAGE'),
  FETCH_OWNER_POOL_HISTORY_REQUEST: '@USER_DETAILS_PAGE/FETCH_OWNER_POOL_HISTORY_REQUEST',
  SET_OWNER_POOL_HISTORY: '@USER_DETAILS_PAGE/SET_OWNER_POOL_HISTORY',
  SET_OWNER_POOL_LOADING: '@USER_DETAILS_PAGE/SET_OWNER_POOL_LOADING',
  SET_OWNER_POOL_ERROR: '@USER_DETAILS_PAGE/SET_OWNER_POOL_ERROR',
  ASSIGN_TO_OWNER_POOL_REQUEST: '@USER_DETAILS_PAGE/ASSIGN_TO_OWNER_POOL_REQUEST',
  REMOVE_FROM_OWNER_POOL_REQUEST: '@USER_DETAILS_PAGE/REMOVE_FROM_OWNER_POOL_REQUEST',
  TOGGLE_OWNER_POOL_DIALOG: '@USER_DETAILS_PAGE/TOGGLE_OWNER_POOL_DIALOG',
};
const actions = {
  ...getActionCreators(constants),
  fetchOwnerPoolHistory: createAction(constants.FETCH_OWNER_POOL_HISTORY_REQUEST),
  setOwnerPoolHistory: createAction(constants.SET_OWNER_POOL_HISTORY),
  setOwnerPoolLoading: createAction(constants.SET_OWNER_POOL_LOADING),
  setOwnerPoolError: createAction(constants.SET_OWNER_POOL_ERROR),
  assignToOwnerPool: createAction(constants.ASSIGN_TO_OWNER_POOL_REQUEST),
  removeFromOwnerPool: createAction(constants.REMOVE_FROM_OWNER_POOL_REQUEST),
  toggleOwnerPoolDialog: createAction(constants.TOGGLE_OWNER_POOL_DIALOG),
};
const actionHandlers = getActionHandlers(constants);
const reducer = buildReducer(initialState, {
  ...actionHandlers,
  [constants.ADD_LOADED_ITEM]: (state, action) => ({
    ...state,
    isLoading: false,
    isPushing: false,
    didLoad: true,
    data: action.payload,
  }),
  [constants.FETCH_OWNER_POOL_HISTORY_REQUEST]: (state) => ({
    ...state,
    ownerPool: { ...state.ownerPool, loading: true, error: null },
  }),
  [constants.SET_OWNER_POOL_HISTORY]: (state, action) => ({
    ...state,
    ownerPool: { ...state.ownerPool, history: action.payload, loading: false },
  }),
  [constants.SET_OWNER_POOL_LOADING]: (state, action) => ({
    ...state,
    ownerPool: { ...state.ownerPool, loading: action.payload },
  }),
  [constants.SET_OWNER_POOL_ERROR]: (state, action) => ({
    ...state,
    ownerPool: { ...state.ownerPool, error: action.payload, loading: false },
  }),
  [constants.TOGGLE_OWNER_POOL_DIALOG]: (state, { payload: { dialog, show } }) => ({
    ...state,
    ownerPool: { 
      ...state.ownerPool, 
      [dialog]: show,
      error: show ? null : state.ownerPool.error,
    },
  }),
  [LOCATION_CHANGE]: (state, { payload }) => (
    matchPath(payload.location.pathname, routeConfig)
      ? state
      : initialState
  ),
});

export { constants, actions, reducer };
